import { Divider, Grid, Stack, Typography } from "@common-ui/ui";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import EmailIcon from "@mui/icons-material/Email";

export const AddressComponent = ({ address, addressType }) => {
  const addressIcons = {
    Billing: {
      icon: (
        <StoreIcon
          fontSize="small"
          style={{ verticalAlign: "middle", marginRight: 5 }}
          color="disabled"
        />
      ),
      label: "Billing",
    },
    Building: {
      icon: (
        <BusinessIcon
          fontSize="small"
          style={{ verticalAlign: "middle", marginRight: 5 }}
          color="disabled"
        />
      ),
      label: "Building",
    },
    Shipping: {
      icon: (
        <LocalShippingIcon
          fontSize="small"
          style={{ verticalAlign: "middle", marginRight: 5 }}
          color="disabled"
        />
      ),
      label: "Shipping",
    },
    Mailing: {
      icon: (
        <EmailIcon
          fontSize="small"
          style={{ verticalAlign: "middle", marginRight: 5 }}
          color="disabled"
        />
      ),
      label: "Mailing",
    },
  };

  return (
    <>
      <Stack sx={{ mt: 1, p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Typography fontWeight="700" variant="h4" fontSize="0.7rem">
              {addressIcons[addressType].icon}
              {addressIcons[addressType].label} Address
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              Address 1
            </Typography>
            <Typography variant="body2">{address.address_line_1}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              City
            </Typography>
            <Typography variant="body2">{address?.city}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              Country / Region
            </Typography>
            <Typography variant="body2">
              {address?.country_or_region}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              Address 2
            </Typography>
            <Typography variant="body2">{address?.address_line_2}</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              State / Province
            </Typography>
            <Typography variant="body2">
              {address?.state_or_province}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography fontSize={12} variant="h4" fontWeight="700">
              Zip / Postal Code
            </Typography>
            <Typography variant="body2">{address?.postal_code}</Typography>
          </Grid>
        </Grid>
      </Stack>
      <Divider sx={{ mb: 3 }} />
    </>
  );
};
